import React from 'react';
import FeeScheduleList from '../component/fee-schedule/FeeScheduleList';

const FeeSchedulePage: React.FC = () => {
  return (
    <div className="md:p-6 lg:p-8 p-4 mx-auto">
      <h1 className="text-2xl font-bold mb-4">Quản lý biểu phí</h1>
      <FeeScheduleList />
    </div>
  );
};

export default FeeSchedulePage;
